import { render, staticRenderFns } from "./subSupplierComplianceConfirm.vue?vue&type=template&id=4a7a2e2e&scoped=true"
import script from "./subSupplierComplianceConfirm.vue?vue&type=script&lang=js"
export * from "./subSupplierComplianceConfirm.vue?vue&type=script&lang=js"
import style0 from "./subSupplierComplianceConfirm.vue?vue&type=style&index=0&id=4a7a2e2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7a2e2e",
  null
  
)

export default component.exports